// Copyright (c) 2019 Comsearch, Inc., All rights reserved

// gets the bands that are used in a project and gives a count for how many
// paths are using that band.
// eg.
// {
//    [null]: 2,
//    1: 3,
//    5: 12,
// }
// means that there are two paths with no band assigned,
// there are 3 paths with band id 1 assigned
// and there are 12 paths with band id 5 assigned.

const getUsedBandsCounts = () => (dispatch, getState) => (
  getState().projectSummary.get('paths').reduce((a, d) => {
    // default the band value to null
    const bandId = d.get('bandId') || null

    // if we've already stored this band, add to its count
    if (a[bandId]) {
      ++a[bandId]
      // otherwise add it to the hash and set its count to 1.
    } else {
      a[bandId] = 1
    }
    return a
  }, {}) // defaulting this value makes it easier to handle when all paths have bands assigned.
)

export default getUsedBandsCounts
